<div class="modal fade show d-block" tabindex="-1" role="dialog" (click)="onBackdropClick($event)">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content rounded-4 shadow border-0">
            <div class="modal-header border-0 pb-0">
                <h5 class="modal-title d-flex align-items-center gap-2">
                    <span class="material-symbols-outlined text-colonial">how_to_reg</span>
                    Revisar solicitud de registro
                </h5>
                <button type="button" class="btn-close" (click)="onCancel()"></button>
            </div>

            <div class="modal-body">
                <div *ngIf="loading" class="text-muted small">Cargando solicitud...</div>

                <ng-container *ngIf="!loading && detail">
                    <dl class="row mb-3 small">
                        <dt class="col-4 col-md-3">Nombre</dt>
                        <dd class="col-8 col-md-9">{{ detail.firstName }} {{ detail.lastName }}</dd>

                        <dt class="col-4 col-md-3">Correo</dt>
                        <dd class="col-8 col-md-9">{{ detail.email }}</dd>

                        <dt class="col-4 col-md-3">Documento</dt>
                        <dd class="col-8 col-md-9">{{ detail.documentNumber || '-' }}</dd>

                        <dt class="col-4 col-md-3">Rol solicitado</dt>
                        <dd class="col-8 col-md-9">{{ detail.requestedRole }}</dd>

                        <dt class="col-4 col-md-3">Banco</dt>
                        <dd class="col-8 col-md-9">{{ detail.bankName || '-' }}</dd>

                        <dt class="col-4 col-md-3">Sucursal</dt>
                        <dd class="col-8 col-md-9">{{ detail.branchName || '-' }}</dd>

                        <dt class="col-4 col-md-3" *ngIf="detail.notes">Comentarios</dt>
                        <dd class="col-8 col-md-9" *ngIf="detail.notes">{{ detail.notes }}</dd>
                    </dl>

                    <div *ngIf="canEditAssignments" class="mb-3">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="form-label m-0 fw-semibold">
                                {{ isSupervisorRequest ? 'Sucursales asignadas' : 'Banco y sucursal' }}
                            </label>
                            <button *ngIf="isSupervisorRequest" (click)="addRow()"
                                class="btn btn-outline-primary btn-sm" type="button">Agregar</button>
                        </div>

                        <p class="text-muted small" *ngIf="isSupervisorRequest">
                            Confirma o corrige las sucursales que gestionará el supervisor.
                        </p>

                        <div *ngFor="let row of rows; let i = index" class="row g-2 align-items-end mb-2">
                            <div class="col-12 col-md-5">
                                <select class="form-select form-select-sm" [(ngModel)]="row.bankId"
                                    (ngModelChange)="onRowBankChange(row)">
                                    <option [ngValue]="null" disabled>Banco...</option>
                                    <option *ngFor="let b of banks" [ngValue]="b.id">{{ b.name }}</option>
                                </select>
                            </div>
                            <div class="col-12 col-md-5">
                                <select class="form-select form-select-sm" [(ngModel)]="row.branchId">
                                    <option [ngValue]="null" disabled>Sucursal...</option>
                                    <option *ngFor="let br of row.branches" [ngValue]="br.id"
                                        [disabled]="!isBranchAllowed(br.id)">
                                        {{ br.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-12 col-md-2 d-grid" *ngIf="isSupervisorRequest && rows.length > 1">
                                <button (click)="removeRow(i)" class="btn btn-outline-danger btn-sm"
                                    type="button">Quitar</button>
                            </div>
                        </div>
                    </div>

                    <div class="mb-2" *ngIf="!rejecting">
                        <label class="form-label small">Comentarios (opcional)</label>
                        <textarea class="form-control" rows="2" [(ngModel)]="comments"></textarea>
                    </div>

                    <div class="mb-2" *ngIf="rejecting">
                        <label class="form-label small">Motivo del rechazo <span class="text-danger">*</span></label>
                        <textarea class="form-control" rows="2" [(ngModel)]="reason"></textarea>
                    </div>
                </ng-container>
            </div>

            <div class="modal-footer border-0">
                <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancelar</button>

                <ng-container *ngIf="!rejecting">
                    <button type="button" class="btn btn-outline-danger" (click)="rejecting = true">Rechazar</button>
                    <button type="button" class="btn bg-colonial btn-secondary" (click)="onApprove()"
                        [disabled]="loading || !assignmentsComplete">Aprobar</button>
                </ng-container>

                <ng-container *ngIf="rejecting">
                    <button type="button" class="btn btn-outline-secondary" (click)="rejecting = false">Volver</button>
                    <button type="button" class="btn btn-danger" (click)="onReject()"
                        [disabled]="!reason.trim()">Confirmar rechazo</button>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show"></div>
